import {
  FilterTagsWrapper,
  ClearAllTagsContent,
  FilterTagContent,
  FilterTag,
  FilterLabel,
  DismissIcon,
} from './FilterTags.styled';
import { SingleTicketTransformed } from 'src/components/Tickets/models/Tickets.interface';
import { useMemo } from 'react';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const FilterTags = () => {
  const { filterOptions, deleteSingleFilter, deleteAllFilters } =
    useServiceDeskContext();
  const { isAtLeastOneChecked, checkedTags } = useMemo(() => {
    const tags = Object.entries(filterOptions)
      ?.reduce((acc, [colId, options]) => {
        const checkedTags = options
        .reduce((acc, ticket) => {
          if (ticket.checked) {
            return [ ...acc, {
              label: ticket.label,
              columnId: colId as keyof SingleTicketTransformed,
            }];
          }
          return acc;
        }, [])
        if (!checkedTags) return acc;
        return [...acc, ...checkedTags];
      }, [] as { label: string; columnId: keyof SingleTicketTransformed }[])
      .sort((a, b) => a.label.length - b.label.length);
    const isAtLeastOneChecked = tags.length > 0;
    return { isAtLeastOneChecked, checkedTags: tags };
  }, [filterOptions]);

  return (
    <FilterTagsWrapper>
      {isAtLeastOneChecked && (
        <>
          <ClearAllTagsContent>
            <FilterLabel onClick={deleteAllFilters}>Clear all</FilterLabel>
          </ClearAllTagsContent>
          {checkedTags?.map((tag) => (
            <FilterTag key={tag.label}>
              <FilterTagContent title={tag.label}>
                <FilterLabel>{tag.label}</FilterLabel>
                <DismissIcon
                  onClick={() => deleteSingleFilter(tag.columnId, tag.label)}
                />
              </FilterTagContent>
            </FilterTag>
          ))}
        </>
      )}
    </FilterTagsWrapper>
  );
};
